import React, { Component, Fragment } from 'react';
import { apiGet } from 'helpers/ApiHelper';
import { connect } from 'react-redux';
import Auth from 'j-toker';

import { List, AutoSizer } from 'react-virtualized';
import MediaQuery from 'react-responsive';

import { showFailure } from 'actions/notificationActions';
import { toFriendlyDateString } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';
import { deepDiver } from 'helpers/utilities';
import { formatMoney } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';

const DEFAULT_ROW_HEIGHT = 100;
class PaymentReceiptsTable extends Component {
  downloadRentReceipt = payment => {
    const ledgerId = payment.Id;
    apiGet(Auth.getApiUrl() + `/leads/bpms_payments/${ledgerId}/receipt`, {
      method: 'GET',
    })
      .then(response => {
        const linkSource = `data:application/pdf;base64,${response.data}`;
        const downloadLink = document.createElement('a');
        const fileName = `receipt-${ledgerId}-${payment.TransactionDate}.pdf`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch(() => {
        this.props.showFailure(getTranslatedString('couldNotFetchReceipt'));
      });
  };

  rowHeight = (index, tableData, isMobile = false) => {
    const memo = deepDiver(tableData[index], 'Memo');

    if (!!memo && isMobile) {
      let lines = Math.ceil(memo.length / 20) - 1;

      return DEFAULT_ROW_HEIGHT + lines * 20;
    } else if (!!memo) {
      let lines = Math.ceil(memo.length / 50) - 1;
      return DEFAULT_ROW_HEIGHT + lines * 20;
    }

    return DEFAULT_ROW_HEIGHT;
  };

  maxHeight = (isMobile = false) => {
    let height = 40;
    this.props.data.forEach(data => {
      const memo = deepDiver(data, 'Memo');
      if (!!memo && isMobile) {
        let lines = Math.ceil(memo.length / 20) - 1;

        height += DEFAULT_ROW_HEIGHT + lines * 20;
      } else if (!!memo) {
        let lines = Math.ceil(memo.length / 50) - 1;
        height += DEFAULT_ROW_HEIGHT + lines * 20;
      } else {
        height += DEFAULT_ROW_HEIGHT;
      }
    });
    return height;
  };

  render() {
    return (
      <Fragment>
        <MediaQuery query="(max-device-width: 750px)">
          <div
            className="mobile_card"
            style={{
              height: `${this.maxHeight(true)}px`,
              padding: '15px',
              maxWidth: '900px',
              margin: 'auto',
            }}
          >
            <AutoSizer>
              {({ height, width }) => (
                <List
                  rowCount={this.props.data.length}
                  rowHeight={({ index }) => this.rowHeight(index, this.props.data, true)}
                  rowRenderer={({ key, index, style }) =>
                    this._rowRenderer({ key, index, style }, this.props.data)}
                  width={width}
                  height={height}
                  style={{ borderTop: `2px solid ${AccentColor()}` }}
                />
              )}
            </AutoSizer>
          </div>
        </MediaQuery>
        <MediaQuery query="(min-device-width: 751px)">
          <div
            className="mobile_card"
            style={{
              height: `${this.maxHeight(false)}px`,
              padding: '15px',
              maxWidth: '900px',
              margin: 'auto',
            }}
          >
            <AutoSizer>
              {({ height, width }) => (
                <List
                  rowCount={this.props.data.length}
                  rowHeight={({ index }) => this.rowHeight(index, this.props.data, false)}
                  rowRenderer={({ key, index, style }) =>
                    this._rowRenderer({ key, index, style }, this.props.data)}
                  width={width}
                  height={height}
                  style={{ borderTop: `2px solid ${AccentColor()}` }}
                />
              )}
            </AutoSizer>
          </div>
        </MediaQuery>
      </Fragment>
    );
  }

  _rowRenderer = ({ key, index, style }, data) => {
    const payments = data;
    let rowStyle = Object.assign(
      { borderBottom: `1px solid ${colors.LIGHT_GRAY}`, padding: '15px 10px' },
      style
    );
    const dueOnVerbiage = !!payments[index].payment_type
      ? getTranslatedString('dueOn')
      : getTranslatedString('receivedOn');

    return (
      <div
        id="mobile_card"
        key={key}
        style={rowStyle}
        onClick={() => this.props.toggleDialog(payments[index])}
      >
        <div className="row" />
        <div className="row">
          <div style={{ display: 'flex' }}>
            {' '}
            <h3
              style={{
                fontSize: '18px',
                flex: 1,
                margin: 0,
                fontFamily: 'Circular-Bold',
                textTransform: 'capitalize',
                whiteSpace: 'pre-line',
              }}
            >
              {payments[index].Memo}
            </h3>
            <p
              style={{
                margin: 0,
                textAlign: 'left',
                fontSize: '16px',
                fontFamily: 'Circular-Black',
                color: payments[index].Credit === 0 ? 'red' : 'green',
              }}
            >
              {payments[index].Debit === 0
                ? `-${formatMoney(payments[index].Credit)}`
                : formatMoney(payments[index].Debit)}
            </p>
          </div>
        </div>
        <div className="row" style={{ display: 'flex' }}>
          <p className="mobile_subheader" style={{ flex: 1, fontSize: '12px', paddingTop: '5px' }}>
            {dueOnVerbiage}{' '}
            {toFriendlyDateString(payments[index].TransactionDate, {
              language: this.props.currentLanguage,
            })}
          </p>
        </div>
        {this._renderRentReceipt(payments[index])}
      </div>
    );
  };

  _renderRentReceipt = payment => {
    if (payment.HasReceipt === false) return;

    return (
      <div className="row">
        <div className="mobile_subheader">
          <button
            type="button"
            className="link-button"
            onClick={() => this.downloadRentReceipt(payment)}
            style={{ cursor: 'pointer', fontFamily: 'Circular-Bold' }}
          >
            {getTranslatedString('viewPrintReceipt')}
          </button>
        </div>
      </div>
    );
  };
}

PaymentReceiptsTable = connect(null, {
  showFailure,
})(PaymentReceiptsTable);

export default PaymentReceiptsTable;
